var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-xl d-flex justify-center align-center",attrs:{"flat":"","outlined":""}},[_c('v-card-title',{staticClass:"text-center title-wrap"},[_vm._v("\n    Конкурс студентов "+_vm._s(_vm.nameFaculty)+" на повышенную государственную академическую стипендию (ПГАС)\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }